package network

import io.ktor.websocket.*

class WsSessionAdapter {
    lateinit var webSocketSession: DefaultWebSocketSession
    var isInit = false
        private set

    var id: Int = -1

    fun initialize(webSocketSession: DefaultWebSocketSession) {
        this.webSocketSession = webSocketSession
        isInit = true
    }

    fun timeoutMills() = webSocketSession.timeoutMillis
}
